import GameConfig from "../core/data/GameConfig";
import { GameObject } from "../core/GameObject";
import { GameScene } from "../scenes/GameScene";

export default class LaunchMeter extends GameObject {
    gameScene: GameScene;
    power: number;
    time: number;
    needle: Phaser.GameObjects.Image;
    min: number;
    max: number;
    paused: boolean;
    glow: Phaser.GameObjects.Image;
    indicator: Phaser.GameObjects.Image;
    constructor(scene: GameScene) {
        super(scene);
        this.gameScene = scene;
        this.power = 0;
        this.time = 0;
        this.paused = false;

        const bg = this.addImage("launchMeterBG");
        const needle = this.needle = this.addImage("launchMeterNeedle");
        const glow = this.glow = this.addImage("launchMeterGlow");
        const indicator = this.indicator = this.addImage("launchMeterIndicator");
        this.setSize(bg.width, bg.height);
        needle.setOrigin(0.5, 0.75);
        needle.y += this.height/2;

        scene.alignIn.TopCenter(indicator, bg, 0, indicator.height/3);
        scene.alignIn.Center(glow, indicator, 0, 0);

        glow.setScale(0);
        this.min = GameConfig.get("LaunchPowerMin");
        this.max = GameConfig.get("LaunchPowerMax");
    }

    update(dt: number): void {
        if (this.paused) return;
        this.time += dt
        this.power = Math.sin(this.time*2);
        this.needle.angle = this.power * 90;
        const angle = 25;
        if (Math.abs(this.needle.angle) <= angle) {
            this.glow.scale = 2 * (angle - Math.abs(this.needle.angle))/angle;
        } else this.glow.scale = 0;
        super.update(dt);
    }

    getPower(): number {
        const multiplier = this.max - ((this.max - this.min) * Math.abs(this.power));
        console.log("Multiplier: ", multiplier);
        return multiplier;
    }

    isPerfect(): boolean {
        return this.getPower() > 0.97;
    }

    tweenUI(): void {
        this.update = () => {};
        this.scene.tweens.add({
            targets: this,
            y: this.y + this.height,
            duration: 750,
            delay: 250,
            ease: Phaser.Math.Easing.Quadratic.In,
            onComplete: () => this.setVisible(false)
        })
    }

    pause(pause: boolean): void {
        this.paused = pause;
    }

    playPerfAnim(): void {
        const glowDuration = 200;
        this.scene.tweens.add({
            targets: this.glow,
            scale: {from: 2, to: 0},
            yoyo: true,
            loop: -1,
            duration: glowDuration,
        });

        this.scene.tweens.add({
            targets: this.indicator,
            scale: 1.35,
            yoyo: true,
            loop: -1,
            duration: glowDuration * 2,
        });
    }

    hideGlow(): void {
        this.scene.tweens.add({
            targets: this.glow,
            scale: 0,
            duration: 100,
        });
    }

    playIntroTween(): void {
        this.scene.tweens.add({
            targets: this,
            y: this.y - this.height - 50,
            duration: 750,
            ease: Phaser.Math.Easing.Quadratic.In,
        })
    }
}